import BcDataTable from './bc-data-table'
import './bc-data-table.scss'

export default BcDataTable
